import React, { useContext } from 'react';
import { debounce } from 'debounce';

import Paper from '@material-ui/core/Paper';
import FireDataContext from '../../../services/firebase/FireDataContext';
import AddressForm from '../../organizations/AddressForm';

const OrganizationAddressInput = ({ organization = {}, title="Invoice Address", onChange }) => {
    const db = useContext(FireDataContext);
    const path = `organizations/${organization.id}`;

    const handleChange = debounce(updated => {
        
        const address = {
            lines: updated.lines.map(value => value ?? ''),
            postcode: updated.postcode ?? ''
        };

        if (onChange) {
            // if we were passed an onChange handler then let that make any required updates to simplify state management in the parent
            onChange({ address })
        }
        else {
            db.update({
                path,
                payload: {
                    address
                }
            })
                .catch(error => console.log(error));
        }

    }, 500);

    return (
        <Paper style={{ padding: '1rem' }}>
            <AddressForm address={organization.address ?? { lines: ['', '', '', ''], postcode: '' }} title={title} onChange={handleChange} />
        </Paper>
    );
};

export default OrganizationAddressInput;